import React, { FC, useCallback, useState } from 'react';
import { Text, View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import i18n from 'i18n-js';
import OperatorName from '@components/operatorPanel/components/elements/operatorName';
import { machineStatusName, navigateTo, navigationRef } from '@helpers';
import { useFocusEffect, useIsFocused } from '@react-navigation/native';
import { OPERATOR_PANEL_PADDING, OPERATOR_PANEL_HEADER_HEIGHT } from '@components/operatorPanel/constants/operatorPanel.constants';
import TouchableElement from '@components/common/touchableElement';
import { TourTarget } from '@components/tours';
import { OPERATOR_PANEL_TOUR_IDS } from '@components/tours/config/operatorPanel/constants';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface HomePageHeaderProps extends Pick<PanelProps, 'CC' | 'isOperator' | 'insetTop' | 'scale' | 'font'> {
  machineName: string;
  machineStatus?: string;
  bgColor?: string;
}

const HomePageHeader: FC<HomePageHeaderProps> = ({
  CC,
  machineName,
  machineStatus,
  isOperator = true,
  bgColor = 'Overlay/Dark/Dim light',
  insetTop,
  scale = initialScale,
  font = initialFont,
}) => {
  const isFocused = useIsFocused();
  const route = navigationRef?.current?.getCurrentRoute();

  const onOperatorBlockPress = () => {
    navigateTo('OperatorPanelSettings', { id: route?.params?.id });
  };

  const onMachineNamePress = () => {
    navigateTo('OperatorPanelSettingsMachineSelect', { id: route?.params?.id });
  };

  return (
    <TourTarget
      tourId={OPERATOR_PANEL_TOUR_IDS.HEADER}
      style={{
        height: scale(OPERATOR_PANEL_HEADER_HEIGHT + insetTop),
        width: '100%',
        backgroundColor: CC(bgColor),
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 100000,
      }}
    >
      <View style={{ height: scale(insetTop) }} />
      <TouchableElement onPress={onMachineNamePress}>
        {({boxStyle}) => (
          <View
            style={[
              boxStyle,
              {
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }]}
          >
            <Text
              testID={TEST_IDS.operatorPanel.home.machineName}
              style={[
                font['Headline Large'],
                {
                  color: CC('Label/Dark/Primary'),
                  position: 'absolute',
                  left: scale(OPERATOR_PANEL_PADDING),
                },
              ]}
            >
              {machineName}
            </Text>

            {machineStatus && (
              <Text style={[font['Headline Large'], { color: CC(`Status/Dark/${machineStatus}`) }]}>{i18n.t(machineStatusName[machineStatus])}</Text>
            )}

            {!isOperator && <View style={{ width: scale(100) }} />}

            {isOperator && (
              <View
                style={{
                  position: 'absolute',
                  right: scale(OPERATOR_PANEL_PADDING),
                }}
              >
                <OperatorName disabled={!isFocused} onPress={onOperatorBlockPress} CC={CC} scale={scale} font={font} />
              </View>
            )}
          </View>
        )}
      </TouchableElement>
    </TourTarget>
  );
};

export default HomePageHeader;
